const getters = {
  baseUrl:state=>state.user.baseUrl,
  year:state=>state.user.currentYear,
}

export default getters